<template>
    <div>
      <search-header></search-header>
      <section class="content relative">
        <router-view></router-view>
      </section>
    </div>
</template>
<script>
  import SearchHeader from './SearchHeader'
  export default {
    name: 'RateAssistRouterView',
    components: {
      SearchHeader
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/rateassist/components/RateAssistRouterView.vue